import { Box, Button, Theme, makeStyles } from "@material-ui/core";
import DoneIcon from "@material-ui/icons/Done";

import { paymentTypeTitle } from "../../../../app/utils";
import { EFrequencyPaymentType } from "../../../../api/Product/ProductSubscriptionApi";
import { fontFamily } from "../../../../app/theme";
import { useBreakpoint } from "../../../../hooks/useBreakpoint";
import { PriceFormat } from "../../../../components/typography/PriceFormat";

export const SliderItem = ({
  imgUrl,
  name,
  price,
  paymentType,
  selected,
  onAdd,
  onView,
  viewOnly
}: {
  imgUrl?: string;
  name: string;
  price: number;
  paymentType?: EFrequencyPaymentType;
  selected?: boolean;
  onAdd?: () => void;
  onView?: () => void;
  viewOnly?: boolean;
}) => {
  const classes = useStyles();
  const { isMoreThanMd } = useBreakpoint();
  return (
    <Box className={classes.box} p={"15px"} px={isMoreThanMd ? "15px" : 0}>
      <Box className={classes.boxClipPath}>
        <Box className={classes.boxContent} pt={isMoreThanMd ? "49px" : "38px"} px={isMoreThanMd ? "20px" : "35px"}>
          <Box height={isMoreThanMd ? "208px" : "250px"}>
            <img alt={name} src={imgUrl} height={isMoreThanMd ? "208px" : "250px"} style={{ margin: "0 auto" }} />
          </Box>
          <Box textAlign="center">
            <Box
              fontSize={isMoreThanMd ? "18px" : "16px"}
              fontWeight={500}
              color="#160037"
              mt={"16px"}
              minHeight={"44px"}
              letterSpacing={"0.36px"}
              lineHeight={1.22}
            >
              {name}
            </Box>
            <Box fontSize={"18px"} fontWeight={600} color="#160037" mt={"10px"} mb={"11px"}>
              <PriceFormat value={price} />
              {paymentType && <span>&nbsp;{paymentTypeTitle(paymentType, true)}</span>}
            </Box>
            <Box
              display={"flex"}
              flexDirection={isMoreThanMd ? "column" : "row"}
              alignItems={"center"}
              mt={isMoreThanMd ? 0 : "45px"}
              justifyContent={"space-between"}
            >
              <Box>
                <Button className={classes.btnLink} onClick={onView}>
                  More Details
                </Button>
              </Box>

              <Box mt={isMoreThanMd ? "20px" : 0}>
                <Button
                  variant="contained"
                  color="secondary"
                  disabled={viewOnly}
                  className={classes.btnAdd}
                  onClick={onAdd}
                >
                  <Box pr={selected ? 1 : 0} component="span" alignItems="center">
                    {selected && <DoneIcon className={classes.icon} fontSize="small" />}
                  </Box>
                  {selected ? "Added" : "Add"}
                </Button>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  box: {
    maxWidth: 430,
    minHeight: 500,
    borderRadius: 4,
    position: "relative",
    margin: "0 auto",
    filter: "drop-shadow(0px 5px 5px rgba(0, 0, 0, 0.07)) drop-shadow(0px 10px 15px rgba(50, 50, 93, 0.1))",
    [theme.breakpoints.down("sm")]: {
      width: 340
    }
  },
  boxClipPath: {
    maxWidth: 430,
    height: 500,
    filter: "url(#round)"
  },
  boxContent: {
    maxWidth: 430,
    height: 500,
    background: "#fff",
    clipPath: "polygon(calc(100% - 45px) 0, calc(100% - 45px) 45px, 100% 45px, 100% 100%, 0 100%, 0 0)",
    [theme.breakpoints.down("sm")]: {
      clipPath: "polygon(calc(100% - 60px) 0, calc(100% - 60px) 45px, 100% 45px, 100% 100%, 0 100%, 0 0)"
    }
  },
  btnLink: {
    "padding": 0,
    "& .MuiButton-label": {
      borderBottom: "2px solid #f7815c",
      color: "#f7815c",
      fontFamily: fontFamily.Axiforma,
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: 1
    }
  },
  btnAdd: {
    "width": "128px",
    "height": "38px",
    "borderRadius": "18px",
    "boxShadow": "none",
    "fontSize": "14px",
    "fontFamily": fontFamily.Axiforma,
    "fontWeight": 400,
    "& .MuiButton-label": { marginTop: "3px" },
    "&:hover": { boxShadow: "none" },
    "&:disabled": {
      background: "#f7815c",
      color: "#fff",
      opacity: "0.7"
    }
  },
  icon: {
    verticalAlign: "sub"
  }
}));
